var map = {
	"./title-carousel.de-CH.json": 1215,
	"./title-carousel.de-DE.json": 1216,
	"./title-carousel.en-CA.json": 1217,
	"./title-carousel.en-GB.json": 1218,
	"./title-carousel.en-IN.json": 1219,
	"./title-carousel.en-ME.json": 1220,
	"./title-carousel.en-US.json": 1221,
	"./title-carousel.es-EM.json": 1222,
	"./title-carousel.es-ES.json": 1223,
	"./title-carousel.fr-BE.json": 1224,
	"./title-carousel.fr-CA.json": 1225,
	"./title-carousel.fr-CH.json": 1226,
	"./title-carousel.nl-BE.json": 1227,
	"./title-carousel.nl-NL.json": 1228,
	"./title-carousel.pl-PL.json": 1229,
	"./title-carousel.pt-BR.json": 1230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1214;